import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "@/utils/createClassNameString";

import { getAutomationDataAttr } from "../../utils/automationUtils";

import "./styles.scss";

export const Text = ({ children, className, color, layout, testId, type, ...props }) => {
  const layoutClass = layout === "block" ? "tw:block" : "";

  return (
    <span
      className={createClassNameString(["apti-CL apti-Text", className, type, color, layoutClass])}
      {...getAutomationDataAttr(testId)}
      {...props}
    >
      {children}
    </span>
  );
};

Text.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.string,
  layout: PropTypes.oneOf(["block", "inline"]),
  testId: PropTypes.string,
  type: PropTypes.string,
};

Text.defaultProps = {
  children: "",
  className: undefined,
  color: undefined,
  layout: "inline",
  testId: undefined,
  type: undefined,
};
